import { type FC } from "react";

export type SafeAreaTopProps = object;

export const getSafeAreaInsetTop = () => {
    return "calc(var(--tg-viewport-safe-area-inset-top, 0px) + var(--tg-viewport-content-safe-area-inset-top, 0px))";
};

export const getMaximiumnPopupHeight = () => {
    return `min(95vh, calc(100vh - ${getSafeAreaInsetTop()}))`;
};

export const SafeAreaTop: FC<SafeAreaTopProps> = () => {
    return (
        <div
            className="flex-none"
            style={{
                height: getSafeAreaInsetTop(),
            }}
        />
    );
};

export default SafeAreaTop;
